import styled, { css } from 'styled-components';

const PlatformIcon = styled.i.attrs((props) => ({
  className: `platform-icon-${props.type} ${
    props.size ? `icon--${props.size}` : ''
  }`,
}))`
  color: var(--neutral-10);
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background: var(--neutral-500);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background-clip: border-box;
  ${({ type }) =>
    type &&
    css`
      background: var(--color-${type});
    `}
  ${({ size }) =>
    size &&
    css`
      width: ${size}px;
      height: ${size}px;
      font-size: ${size - (size < 20 ? 8 : 10)}px;
    `}
  ${({ count }) =>
    count &&
    css`
      position: relative;
      &:after {
        position: absolute;
        bottom: -6px;
        left: 55%;
        z-index: 10;
        border-radius: 6px;
        background: var(--neutral-800);
        padding: 2px;
        min-width: 14px;
        content: '${count}';
        color: var(--neutral-10);
        font-weight: normal;
        font-size: 9px;
        line-height: 9px;
        font-family: Tahoma, sans-serif;
        text-align: center;
      }
    `}
`;

export default PlatformIcon;
